
import { AxiosHelper } from '../helpers/AxiosHelper';


const AddEdit = async (formData: FormData) => {
    return AxiosHelper.post('/ServiceOrderComment/AddEdit', formData);
}


const ServiceOrderCommentService = {
    AddEdit,
}

export default ServiceOrderCommentService;